import script from "./BookingStep3.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingStep3.vue?vue&type=script&setup=true&lang=js"

import "./BookingStep3.vue?vue&type=style&index=0&id=14887c0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14887c0c"]])

export default __exports__